












































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Tag } from '@/interfaces/registration/tags/Tag';

@Component
export default class TagCheckBoxPicker extends Vue {
  @Prop() readonly parentTag!: Tag;
    @Prop({ default: () => { return []; } }) readonly value!: Array<number>;
  @Prop() readonly maxSelections!: number;
  @Prop() readonly effectiveCount!: number;
  private initialized = false;
  private collapsedTags: { [key: number]: boolean } = {};

  @Watch('value')
  onValueChanged () {
    if (!this.initialized) {
      this.initializeCollapsedTags();
      this.initialized = true;
    }
  }

  private initializeCollapsedTags () {
    this.parentTag.subTags.forEach(subTag => {
      if (this.isTagSelected(subTag.id!)) {
        this.$set(this.collapsedTags, this.parentTag.id!, true);
      }
    });
  }

  public isTagSelected (id: number): boolean {
    return this.value.findIndex((tag) => tag === id) >= 0;
  }

  public isTagDisabled (id: number): boolean {
    return (
      this.maxSelections != null &&
      this.effectiveCount >= this.maxSelections &&
      !this.isTagSelected(id)
    );
  }

  public toggleTag (id: number): void {
    const tags = [id];
    if (this.value.findIndex((tag) => tag === id) >= 0) {
      this.$emit('removeTags', tags);
    } else {
      const isSubTag = this.parentTag.subTags.some(
        (subTag) => subTag.id === id
      );

      if (isSubTag && !this.isTagSelected(this.parentTag.id!)) {
        tags.push(this.parentTag.id!);
      }

      this.$emit('addTags', tags);
    }
  }

  public toggleParentTag (id: number): void {
    if (this.value.findIndex((tag) => tag === id) < 0) {
      this.$set(this.collapsedTags, id, true);
    }
    this.toggleTag(id);
  }

  public toggleIcon (parentTagId: number): void {
    this.$set(this.collapsedTags, parentTagId, !this.collapsedTags[parentTagId]);
  }
}
